export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_complete_1.eb656f7b.jpg";